import { CreateSearchResults, CreateSearchState } from '../interfaces/create-search.interface';
import { createSlice } from '@reduxjs/toolkit';

/*----- CREATE STORE ------*/
declare interface CreateSearchSlice {
  name: string;
  initialState: CreateSearchState;
  reducers: any;
}

const slice: CreateSearchSlice = {
  name: 'createSearch',
  initialState: {
    search: {
      data: undefined,
      request: undefined,
      isLoading: false,
      isLoaded: false,
      isSuccess: false,
      isFailure: false,
      message: 'No search performed 1',
    },
    currentPageIndex: undefined,
    currentPageSize: undefined,
  },
  reducers: {
    onSuccess: (state: CreateSearchState, { payload }: { payload: CreateSearchResults }): void => {
      state.search = {
        data: payload,
        request: state?.search?.request,
        isLoaded: true,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
        message: `Successfully loaded search`,
      };
    },
    onFailure: (state: CreateSearchState): void => {
      state.search = {
        data: undefined,
        request: state?.search?.request,
        isLoaded: false,
        isLoading: false,
        isSuccess: false,
        isFailure: true,
        message: `Failed to load search`,
      };
    },
    setLoading: (state: CreateSearchState, action: any): void => {
      state.search = {
        data: state?.search?.data,
        request: action.payload,
        isLoaded: state?.search?.isLoaded,
        isLoading: true,
        isSuccess: false,
        isFailure: state?.search?.isFailure,
        message: `Loading search results`,
      };
    },
    setCreateCurrentPageIndex: (state: CreateSearchState, action: any): void => {
      state.currentPageIndex = action.payload;
    },
    setCreateCurrentPageSize: (state: CreateSearchState, action: any): void => {
      state.currentPageSize = action.payload;
    },
  },
};

export const createSearchSlice: any = createSlice(slice);

/*----- EXPORT ACTIONS ------*/
export const onCreateSearchFailure: Function = createSearchSlice.actions.onFailure;
export const onCreateSearchSuccess: Function = createSearchSlice.actions.onSuccess;
export const setCreateCurrentPageIndex: Function = createSearchSlice.actions.setCreateCurrentPageIndex;
export const setCreateCurrentPageSize: Function = createSearchSlice.actions.setCreateCurrentPageSize;
export const setCreateSearchLoading: Function = createSearchSlice.actions.setLoading;

/*----- EXPORT DEFAULT ------*/
export const createSearchReducer = createSearchSlice.reducer;
